import React, { useState, useEffect } from "react";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { CustomersApi } from "./api";
import CustomerFilesTreeView from "./TreeView";

interface CustomersWidgetProps {
  id: string;
  header: string;
  machine?: string;
}
interface TreeViewDataItem {
  text: string;
  expanded?: boolean;
  checked?: boolean;
  selected?: boolean;
  isFolder: boolean;
  items?: TreeViewDataItem[];
}
const SharepointFilesWidget = (props: CustomersWidgetProps) => {
  const [customersData, updateCustomersData] = useState<TreeViewDataItem[]>([]);
  const [customersIsLoading, updateCustomersIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    fetchFiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.machine]);

  const fetchFiles = (): void => {
    updateCustomersIsLoading(true);
    updateCustomersData([]);
    const newParams: any = { machineSerial: props.machine };

    CustomersApi.getMachineFiles(newParams)
      .then((response: any) => {
        if (response !== "canceled") {
          updateCustomersData(response);
          updateCustomersIsLoading(false);
          setErrorMessage(null);
        }
      })
      .catch((error) => {
        if (error.message !== "canceled") {
          updateCustomersIsLoading(false);
          setErrorMessage("Oops something went wrong, unable to get data.");
        }
        // optional: console.error(error);
      });

    CustomersApi.getMachineRoot(newParams)
      .then((response: any) => {
        if (response !== "canceled") {
          // root data ignored for now
        }
      })
      .catch((error) => {
        if (error.message !== "canceled") {
          updateCustomersIsLoading(false);
          setErrorMessage("Oops something went wrong, unable to get data.");
        }
        // optional: console.error(error);
      });
  };

  const clickDownloadFile = (fileUrl: string) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const itemClick = (item: any): void => {
    if (item != null && !item.isFolder) {
      updateCustomersIsLoading(true);

      const path: string = item.path || "";
      const encodedPath = encodeURIComponent(path);

      if (path.includes("Electrical")) {
        // clickDownloadFile(
        //   `https://app-fleetmachinedata-prod-northeurope-001.azurewebsites.net/api/sharepoint/downloadelectrical?path=${encodedPath}`
        // );
      } else if (path.includes("Retrofit")) {
        clickDownloadFile(
          `https://app-fleetmachinedata-prod-northeurope-001.azurewebsites.net/api/sharepoint/downloadretrofit?path=${encodedPath}`
        );
      } else {
        clickDownloadFile(
          `https://app-fleetmachinedata-prod-northeurope-001.azurewebsites.net/api/sharepoint/downloaddeliveries?path=${encodedPath}`
        );
      }

      updateCustomersIsLoading(false);
    } else {
      const newParams: any = {
        machineSerial: props.machine,
        container: item.text,
        folderPath: item.path,
      };

      CustomersApi.getMachineFiles(newParams)
        .then((response: any) => {
          if (response !== "canceled") {
            const newData: any[] = [...customersData];
            const parentContainer: string = response[0].container;
            const mappedData: any[] = [];

            for (let i = 0; i < response.length; i++) {
              const obj: any = {
                text: response[i].name,
                path: response[i].path,
              };

              if (response[i].isFolder) {
                obj.items = [];
                obj.isFolder = true;
              }

              mappedData.push(obj);
            }

            let containerFound = false;

            const addToFolder = (folder: any[]) => {
              for (let i = 0; i < folder.length; i++) {
                if (folder[i].text === parentContainer) {
                  folder[i].items = mappedData;
                  containerFound = true;
                }
                if (folder[i].items != null && !containerFound) {
                  addToFolder(folder[i].items);
                }
              }
            };

            addToFolder(newData);

            if (!containerFound && response.length > 0) {
              const obj: any = {
                text: parentContainer,
                items: mappedData,
              };
              newData.push(obj);
            }

            updateCustomersData(newData);
            updateCustomersIsLoading(false);
            setErrorMessage(null);
          }
        })
        .catch((error) => {
          if (error.message !== "canceled") {
            updateCustomersIsLoading(false);
            setErrorMessage("Oops something went wrong, unable to get data.");
          }
          // optional: console.error(error);
        });
    }
  };

  if (customersIsLoading) {
    return <Spinner text="data" />;
  } else if (customersData != null && customersData.length === 0) {
    return (
      <ErrorMessage
        text={"No data found for selected filters."}
        id={props.id}
        header={props.header}
      />
    );
  } else if (errorMessage) {
    return (
      <ErrorMessage text={errorMessage} id={props.id} header={props.header} />
    );
  } else if (customersData != null && customersData.length > 0) {
    return (
      <>
        <CustomerFilesTreeView
          data={customersData}
          itemClick={itemClick}
          source="sharepoint"
        />
      </>
    );
  }

  return null;
};

export default SharepointFilesWidget;











